export default __webpack_public_path__ + "static/moshtix-7e506c3a50b1d9c038e2843633b15622.jpg";